import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; 
import App from './App';
import SmartChatBot from './components/SmartChatBot.jsx';  // Aquí agregamos el chatbot

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <SmartChatBot />  {/* Si agregas aquí el componente SmartChatBot */}
  </React.StrictMode>
);
